export default "__VITE_ASSET__D0tEimAd__"